export const options = [
  { label: 'New', value: 'new' },
  { label: 'Open', value: 'open' },
  { label: 'Close', value: 'close' },
];

export const columnDefs = [
  {
    field: 'candidateName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'yearsOfExperience',
    headerName: 'Exp',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'emailId',
    headerName: 'Email',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'vendorName',
    headerName: 'Vendor Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'createdDate',
    headerName: 'Received on',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'earliestAvailability',
    headerName: 'Available By',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'resumePath',
    headerName: 'Resume',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
  {
    field: 'additionalDocumentsPath',
    headerName: 'Initial Screening Feedback',
    filterParams: { hideMenu: false },
    sortParams: { enabled: false },
  },
  {
    field: 'url',
    headerName: 'Links',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'status',
    headerName: 'Status',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'action',
    headerName: 'Review',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
];

export const candidateExportColumns = [
    { field: 'candidateName', headerName: 'Candidate Name' },
    { field: 'yearsOfExperience', headerName: 'Years of Experience' },
    { field: 'emailId', headerName: 'Email' },
    { field: 'location', headerName: 'Location' },
    { field: 'vendorName', headerName: 'Vendor Name' },
    { field: 'createdDate', headerName: 'Received On' },
    { field: 'earliestAvailability', headerName: 'Available By' },
    { field: 'url', headerName: 'Link' },
    { field: 'status', headerName: 'Status' },
  ];
